import { createReducer, SerializedError } from "@reduxjs/toolkit";
import { checkLicense, fetchStartup, resetNotification, setCustomerCode } from "../actions/app";
import { DelegatedAuthStyle } from "../../model/app/DelegatedAuthStyle";
import { insertAbsencesToMultipleDates } from "../actions/absenceInsertion";
import { uploadAttachment } from "../actions/worksheet";
import { LOCALSTORAGE_CUSTOMERCODE } from "../../constants/common";

export interface IAppState {
    isFetching: boolean;
    isEnabled: boolean;
    canRunWindowsAuth: boolean;
    isDelegatedAuthEnabled: boolean;
    delegatedAuthStyle: DelegatedAuthStyle;
    delegatedAuthCustomizableText: string;
    error?: SerializedError;
    successResponse?: string;
    errorResponse?: string;
    notificationVisible: boolean;
    multiTenant: boolean;
    customerCode: string;
}

export const appReducer = createReducer<IAppState>(
    {
        isFetching: false,
        isEnabled: false,
        canRunWindowsAuth: false,
        isDelegatedAuthEnabled: false,
        delegatedAuthStyle: DelegatedAuthStyle.automaticRedirection,
        delegatedAuthCustomizableText: "",
        notificationVisible: false,
        multiTenant: false,
        customerCode: localStorage.getItem(LOCALSTORAGE_CUSTOMERCODE) ?? "",
    },
    builder =>
        builder
            .addCase(fetchStartup.pending, (state, action) => ({
                ...state,
                isFetching: true,
                error: undefined,
            }))
            .addCase(fetchStartup.fulfilled, (state, action) => ({
                ...state,
                isFetching: false,
                error: undefined,
                isEnabled: action.payload.isAppEnabled ?? false,
                canRunWindowsAuth: action.payload.canRunWindowsAuth ?? false,
                isDelegatedAuthEnabled: action.payload.isDelegatedAuthEnabled ?? false,
                delegatedAuthStyle: action.payload.delegatedAuthStyle ?? DelegatedAuthStyle.automaticRedirection,
                delegatedAuthCustomizableText: action.payload.delegatedAuthCustomizableText ?? "",
                multiTenant: action.payload.multiTenant ?? false,
            }))
            .addCase(fetchStartup.rejected, (state, action) => ({
                ...state,
                isFetching: false,
                error: action.error,
                isEnabled: false,
                canRunWindowsAuth: false,
            }))
            .addCase(resetNotification, (state, action) => ({
                ...state,
                notificationVisible: false,
                successResponse: undefined,
                errorResponse: undefined,
            }))
            .addCase(insertAbsencesToMultipleDates.fulfilled, (state, action) => {
                switch (action.payload) {
                    case "over_limit":
                        return {
                            ...state,
                            notificationVisible: true,
                            errorResponse: action.payload as string,
                        };
                    case "date_reserved_unava":
                        return {
                            ...state,
                            notificationVisible: true,
                            errorResponse: action.payload as string,
                        };
                    default:
                        return state;
                }
            })
            .addCase(uploadAttachment.rejected, (state, action) => ({
                ...state,
                errorResponse: "attachment_upload_error",
                notificationVisible: true,
            }))
            .addCase(setCustomerCode, (state, action) => ({
                ...state,
                customerCode: action.payload,
            }))
            .addCase(checkLicense.fulfilled, (state, action) =>
                !action.payload
                    ? {
                          ...state,
                          errorResponse: "license_error",
                          notificationVisible: true,
                      }
                    : state
            )
);
